import React from 'react';
import { cn } from '@/lib/utils';

interface DebtDroneMarkProps {
  className?: string;
}

const DebtDroneMark: React.FC<DebtDroneMarkProps> = ({ className }) => (
  <img
    src="/debtdrone-logo.svg"
    alt="DebtDrone"
    aria-label="DebtDrone"
    className={cn('block', className)}
  />
);

export default DebtDroneMark;
